// extracted by mini-css-extract-plugin
module.exports = {"root":"MeetingMessage_root__2BBOs"};